import React, { FC, useEffect, useState } from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormInstance } from 'antd/lib/form';

import {
  AddressInputGroup,
  CountryInput,
  Form,
  ExpansionForm,
  IndividualDocumentTypeInput,
} from '~/components';
import { Beneficiary } from '~/types';
import { phoneValidation } from '~/utils';
import PhoneInput from '~/components/PhoneInput';

interface Props {
  form: FormInstance;
  initialValues?: Beneficiary;
  edit?: boolean;
}

const IndividualForm: FC<Props> = (props) => {
  const { form, initialValues } = props;
  const [t] = useTranslation('payouts');
  const dt = (key: string): string => t(`translation:${key}`);

  const [country, setCountry] = useState('');

  useEffect(() => {
    const { country: formCountry } = form.getFieldsValue() || {};
    setCountry(formCountry);
    if (!initialValues?.document) {
      form.resetFields(['document']);
    }
  }, [form, initialValues]);

  return (
    <>
      <Form.Item name="country" label={dt('country')} rules={[{ required: true }]}>
        <CountryInput onChange={setCountry} placeholder={t('selectCountry')} allowClear />
      </Form.Item>
      <Form.Item name={['firstName']} label={dt('firstName')} rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name={['lastName']} label={dt('lastName')} rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <ExpansionForm
        label={t('addIdentificationInfo')}
        disabled={!country}
        defaultOpen={!!initialValues?.document?.type}
      >
        <Form.Item name={['document', 'type']} label={t('identificationMethod')}>
          <IndividualDocumentTypeInput
            country={country as any}
            placeholder=""
            allowClear
            disabled={!country}
          />
        </Form.Item>
        <Form.Item name={['document', 'number']} label={t('identificationNumber')}>
          <Input />
        </Form.Item>
      </ExpansionForm>
      <ExpansionForm label={t('addAddress')} defaultOpen={!!initialValues?.address?.postalCode}>
        <AddressInputGroup excludeInputs={['country', 'cityLocalized']} />
      </ExpansionForm>
      <ExpansionForm
        label={t('addContacts')}
        defaultOpen={!!initialValues?.phoneNumber || !!initialValues?.email}
      >
        <Form.Item
          name="phoneNumber"
          label={dt('phoneNumber')}
          rules={[{ validator: phoneValidation }]}
        >
          <PhoneInput />
        </Form.Item>
        <Form.Item name="email" label={dt('email')} rules={[{ type: 'email' }]}>
          <Input />
        </Form.Item>
      </ExpansionForm>
    </>
  );
};

export default IndividualForm;
